export default `
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
